import Vue from 'vue';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import SimpleScroller from '@kids/lib/class/SimpleScroller';
import responder from '@kids/lib/service/responder';
import App from './App.vue';
import router from './router';
import store from './store';
import modules from './static/modules.json';
import './components/global';
import audioController from './service/audioController';

Vue.config.productionTip = false;
Vue.prototype.$audioController = audioController;

gsap.registerPlugin(ScrollToPlugin);

const root = new Vue({
    el: '#app',
    data: {
        modalOpen: false,
        header: {
            title: '',
            subtitle: '',
            onlyHome: true,
            progress: {
                active: false,
                modules: null,
                currentSlide: 0,
                slideCount: 0
            }
        },
        tutorialOffered: false,
        hideScroller: true
    },
    watch: {
        hideScroller(val)
        {
            if (val)
            {
                this.$el.parentElement.classList.add('hide-track');
                return;
            }
            this.$el.parentElement.classList.remove('hide-track');
        }
    },
    store,
    router,
    mounted()
    {
        this._scroller = new SimpleScroller(this.$el.parentElement);
    },
    methods: {
        loadCanvasBackgrounds(backgrounds)
        {
            return this.$children[0].loadCanvasBackgrounds(backgrounds);
        },
        animateTransition(config)
        {
            this.$children[0].animateTransition(config);
        },
        resetHeader(subtitle, title = '', progress = false)
        {
            this.header.title = title || modules[0].mainTitle;
            this.header.subtitle = subtitle;
            this.header.progress.active = progress;
            this.header.onlyHome = false;
        },
        scrollToTop()
        {
            const scrollContainer = this.$el.parentElement;
            if (scrollContainer.scrollTop === 0) { return; }
            gsap.to(scrollContainer, {duration: 0.4, scrollTo: 0});
        },
        refreshScroller()
        {
            this._scroller.refresh();
        },
        prepareHeightChange()
        {
            this.hideScroller = true;
            this.$el.style.height = `${this.$el.clientHeight}px`;
        },
        executeHeightChange(delay)
        {
            if (this.$el.style === 'auto') { return; }
            gsap.to(
                this.$el,
                {
                    delay,
                    duration: 0.4,
                    height: 'auto',
                    onComplete: () =>
                    {
                        this.refreshScroller();
                        this.hideScroller = false;
                    }
                }
            );
        }
    },
    render: h => h(App)
});

responder.on('resize', () => root.refreshScroller());

export default root;
